export const EVENT_STATUSES = [
  "Created",
  "Being planned",
  "Planned",
  "Ready",
  "Done",
];

export const EVENT_TYPES = [
  "A great start of the day",
  "Breakfast Seminar",
  "Case Solving",
  "Company Visit",
  "Eat and Meet",
  "Fika and Mingle",
  "Mock Interview",
  "Office Fun Time",
  "Coffee Boost",
  "Fruit Boost",
  "Goodie Handout",
  "Tailored Marketing",
  "Walk And Talk",
  "Stand event",
  "Lunch Lecture",
  "After School",
];

export const FORM_MAX_CHARS = [
  "25",
  "50",
  "75",
  "100",
  "150",
  "200",
  "300",
  "400",
  "500",
  "600",
  "700",
];

export const DEFAULT_QUESTION = {
  answer: null,
  maxlength: "50",
  message: "",
  required: false,
  placeholder: "",
};

export const DEBOUNCE_TIME = 1000;
